var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M352.464 212h-61.817a22.174 22.174 0 006.165-15.368c0-12.295-9.966-22.261-22.261-22.261-7.745 0-14.563 3.957-18.551 9.958-3.988-6-10.805-9.958-18.551-9.958-12.295 0-22.261 9.966-22.261 22.261A22.178 22.178 0 00221.353 212h-61.817c0 16.393 14.278 29.68 30.67 29.68h-.988c0 16.393 13.289 29.682 29.682 29.682a29.49 29.49 0 003.842 14.595l-24.619 24.621 18.888 18.888 26.794-26.794c1.05.385 2.136.692 3.257.903l-16.191 36.557L256 367.299l25.13-27.167-16.191-36.557a20.303 20.303 0 003.257-.903l26.794 26.794 18.888-18.888-24.621-24.621a29.494 29.494 0 003.842-14.595c16.393 0 29.682-13.289 29.682-29.682h-.988c16.393.001 30.671-13.287 30.671-29.68z"
})));

export default SvgAl;